import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import store from './redux/store';
import App from './App'; // 👈 Import App instead of AppRoutes
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App /> {/* 👈 This wraps AppRoutes and handles session + profile init */}
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
